import React, { useState } from "react";
import { SketchPicker } from "react-color";

export function ColorPicker({
    color: initialColor = "#69913d",
    onChange,
}: {
    color?: string;
    onChange?: (value: string) => void;
}) {
    const [color, setColor] = useState<string>(initialColor);

    return (
        <SketchPicker
            disableAlpha={true}
            presetColors={presetColors}
            color={color}
            onChangeComplete={newColor => {
                setColor(newColor.hex);

                if (onChange) {
                    onChange(newColor.hex);
                }
            }}
        />
    );
}

// These colors are not based on the theme colors - they are picked
// to be visually distinct and work well together in the layout.
const presetColors = [
    "#d08e21",
    "#a03a46",
    "#9F2198",
    "#598AA3",
    "#2b5c74",
    "#73a69e",
    "#69913d",
    "#577535",
];
